import {Button} from "@material-ui/core";

import { useState} from "react";
import ItemsAutoComplete from "../../_customs/ItemsAutoComplete";
import {Grid} from "@mui/material";

export default function SearchBar({onSelection}) {

    const [selected, setSelected] = useState([])

    const handleChange = (data) => setSelected(data)

    const handleSelection = (data) => {
        onSelection && onSelection(selected.map(one=>({
            Id:one?.id,
            Name:one?.name,
            UPC:one?.barCode||one?.barcode || one?.UPC,
            ImageUrl:one?.imageUrl,
            InternalId:one?.internalId
            // Quantity :one?.Qa
        })))

        setSelected([])
    }

    return (

        <Grid container spacing={2}>

            <Grid item xs={9}>
                <ItemsAutoComplete
                    multiple
                    size={'large'}
                    value={selected}
                    onChange={handleChange}
                    minWidth={400}
                />
            </Grid>

            <Grid item xs={2}>
                <Button variant='contained' color='primary' onClick={handleSelection} style={{marginTop:10,marginLeft:5}}>
                    Ajouter
                </Button>
            </Grid>

        </Grid>

    )
}
